<template>
  <div
    :class="['menu drinks-menu', `menu-${menu.id}`, {editable:selected}, {disabled:disabled},{'ui-hidden':hideGlobalUI},{'togo-menu':isTogoMenu}, menuClasses]"
    @mouseover="hovering = true"
    @mouseleave="hovering = false"
    v-toggle-select
    v-on-clickaway="deselect"
    ref="menu"
  >
    <div class="menu-inner" ref="menuInner">
      <div :class="['drinks-menu-col-left menu-col drinks-menu-col']">
        <div class="menu-title-wrap">
          <editable-text
            tag="div"
            class="menu-title"
            :content="menu.acf.menu_title"
            :editable="isEditable"
            @update="menu.acf.menu_title = $event"
          />
        </div>
        <draggable
          v-model="menu.acf.sections"
          :class="['sections']"
          :options="{group:'menu-sections',draggable:'.section',disabled:!isAuthenticated}"
          @start="drag=true"
          @end="drag=false"
        >
          <menu-section
            v-for="(section, section_index) in menu.acf.sections"
            v-if="section.section_isRecurring"
            :menu="menu"
            :section="section"
            :key="section.section_uuid"
            @removeSection="removeSection"
            @itemDragStart="onItemDragStart"
            isDrinksMenuSection
            recurringSection
          />
        </draggable>

        <div class="drinks-menu-col-left-logo">
          <img
            class="footer-logo-img"
            src="../../../static/satsuma-horiz-logo-black.svg"
            alt="Satsuma Café"
          />
          <!-- <img class="footer-logo-img" src="/wp-content/themes/satsuma-wp-theme/spa/dist/satsuma-horiz-logo-black.svg" alt="Satsuma Café"> -->
        </div>
      </div>

      <draggable
        v-model="menu.acf.sections"
        :class="['drinks-menu-col-right sections menu-col drinks-menu-col' ]"
        :options="{group:'menu-sections',draggable:'.section',disabled:!isAuthenticated}"
        @start="drag=true"
        @end="drag=false"
      >
        <menu-section
          v-for="(section, section_index) in menu.acf.sections"
          v-if="!section.section_isRecurring"
          :menu="menu"
          :section="section"
          :key="section.section_uuid"
          @removeSection="removeSection"
          @itemDragStart="onItemDragStart"
          isDrinksMenuSection
        />
      </draggable>

      <transition name="fade">
        <button-cluster
          :class="'menu-button-cluster'"
          v-if="selected || hovering"
          :buttons="buttons"
          :item="menu"
          bottomCenter
        />
      </transition>
    </div>
    <!-- /.menu-inner -->

    <div v-if="isTogoMenu" class="togo-menu-cover-wrap">
      <h1 class="togo-location-title">{{ location.title.rendered }}</h1>
      <img class="togo-cover-img" src="../../../static/togo-menu-logo.svg" alt="Satsuma Café" />

      <h4 class="togo-tagline">
        BREAKFAST. LUNCH.
        <br />COFFEE. JUICE.
      </h4>
      <drinks-menu-footer :location="location" :selected="selected" />
    </div>
    <drinks-menu-footer v-else :location="location" :selected="selected" />

    <div v-if="menu.acf.footer_text && !isTogoMenu" class="menu-board-footer-text">
      <editable-text
        tag="p"
        v-if="menu.acf.footer_text"
        :content="menu.acf.footer_text"
        :editable="isEditable"
        @update="menu.acf.footer_text = $event"
      />
    </div>
    <div v-else-if="isTogoMenu" class="menu-inner-stretch"></div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import axios from "axios";

const testDrinksMenu = require("../testDrinksMenu.js");

import ButtonCluster from "../UI/ButtonCluster";

import draggable from "vuedraggable";
// import fitty from 'fitty'
import VueClickaway from "vue-clickaway";
import ToggleSelect from "../../toggle-select";
import MenuMixin from "./MenuMixin.js";

import _isEqual from "lodash/isEqual";
import _isEqualWith from "lodash/isEqualWith";
import _reduce from "lodash/reduce";
import _cloneDeep from "lodash/cloneDeep";
import _each from "lodash/each";

import moment from "moment";

import EditableTextField from "../EditableTextField";
import MenuSection from "./MenuSection";
import DrinksMenuFooter from "./DrinksMenuFooter";

export default {
  name: "DrinksMenu",
  mixins: [VueClickaway.mixin, ToggleSelect, MenuMixin],
  props: ["menu", "numMenus", "menuOrder", "location"],
  components: {
    draggable,
    "menu-section": MenuSection,
    "editable-text": EditableTextField,
    "button-cluster": ButtonCluster,
    "drinks-menu-footer": DrinksMenuFooter
  },
  computed: {
    hasChanges() {
      // let diffs = this.getDiffKeys(this.menu.acf, this.originalACF)
      return !_isEqualWith(
        this.menu.acf,
        this.originalACF,
        this.isEqualCustomizer
      );
    },
    isEditable() {
      return this.selected && !this.disabled && this.isAuthenticated;
    },
    isTogoMenu() {
      return parseInt(this.wpData.togo);
    }, // isTogoMenu
    ...mapState(["authToken", "wpData"]),
    ...mapGetters(["isAuthenticated"])
  },
  methods: {
    getDiffKeys(a, b) {
      let diffs = _reduce(
        a,
        function(result, value, key) {
          return _isEqual(value, b[key]) ? result : result.concat(key);
        },
        []
      );

      if (diffs.length) {
        _each(diffs, key => {
          console.log(`a['${key}']`, a[key]);
          console.log(`b['${key}']`, b[key]);
          if (![typeof a[key], typeof b[key]].includes("undefined")) {
            this.getDiffKeys(a[key], b[key]);
          }
        });
      }

      return diffs;
    }, // getDiffKeys

    onItemDragStart() {
      this.selected = true;
    }, // onItemDragStart

    onChoose(event) {
      this.dragging = true;
    },

    addSection() {
      if (!this.menu.acf.sections) {
        this.menu.acf.sections = [];
      }

      let newSection = {
        // section_title : `menu ${this.numMenus+1} section ${this.menu.acf.sections.length+1}`,
        section_title: "New Menu Section",
        section_uuid: Date.now() + this.numMenus,
        items: [],
        section_price_columns: [],
        subsections: []
      };

      this.menu.acf.sections.push(newSection);
    }, // addSection

    removeSection(section_id) {
      this.menu.acf.sections = this.menu.acf.sections.filter(
        section => section.section_uuid !== section_id
      );
    }, // removeSection

    clearChanges() {
      this.menu.acf = _cloneDeep(this.originalACF);
      this.menu.acf.last_save_timestamp = Date.now();
      this.deselect();
    }, // clearChanges

    saveMenu() {
      let acfChanges = !_isEqual(this.menu.acf, this.originalACF);
      if (!this.menu.new && !acfChanges) {
        this.$notify("No changes were made");
        return true;
      }

      this.disableEdit();
      // this.$notify(`Saving single menu [${this.menu.id}]..`);
      this.$notify({
        text: `Saving ${this.menu.acf.menu_title} menu...`,
        duration: -1
      });

      this.$store.dispatch("authPromise").then(authToken => {
        let axiosCall = this.menu.new
          ? this.newMenuPost()
          : this.updateMenuPost();

        return axiosCall
          .then(() => {
            this.enableEdit();
            this.$notify({ clean: true });
            this.$notify("Done saving single menu");
            this.updateBirthday();
          })
          .catch(e => {
            this.enableEdit();
            this.$notify({ clean: true });
            this.$notify({ text: "There was a problem saving!", type: "warn" });
            console.log(e.response);
          });
      }); // authPromise
    }, // saveMenu()

    newMenuPost() {
      return axios
        .post(
          `${this.wpData.rest_url}/wp/v2/${this.wpData.cpts.menuBlocks}`,
          {
            title: this.menu.acf.menu_title,
            status: "publish",
            menu_order: this.menuOrder
          },
          { headers: { Authorization: `Bearer ${this.authToken}` } }
        )
        .then(res => {
          this.menu.id = res.data.id;
          this.menu.new = false;

          console.log(`[ New Menu Added ] ID ${this.menu.id}`, res);
          this.$notify(`[ New Menu Added ] ID ${this.menu.id}`);

          // Update add the WP Menu ACF meta
          let newMenuAcfs = this.updateMenuACF();
          return newMenuAcfs;
        });
    }, // newMenuPost()

    updateMenuPost() {
      let menu_id = this.menu.id;

      let menuUpdate;

      let menuData = {
        title: this.menu.acf.menu_title,
        menu_order: this.menuOrder
      };

      menuUpdate = axios
        .put(
          `${this.wpData.rest_url}/wp/v2/${this.wpData.cpts.menuBlocks}/${menu_id}`,
          menuData,
          { headers: { Authorization: `Bearer ${this.authToken}` } }
        )
        .then(res => {
          console.log(`[WP Post Updated for ${menu_id}]`, res);
          // this.$notify(`Updated menu id ${menu_id}`);
          this.originalTitle = this.menu.acf.menu_title;
          return res;
        });

      // Update the WP Menu ACF meta
      let acfUpdate = this.updateMenuACF();

      return axios.all([menuUpdate, acfUpdate]).then(
        axios.spread((menuRes, acfRes) => {
          var resObj = { menuRes: menuRes, acfRes: acfRes };
          console.log(`[Finished all for ${menu_id}]`, resObj);
          return resObj;
        })
      );
    }, //updateMenuPost

    updateMenuACF() {
      // let acfChanges = !_isEqual(this.menu.acf, this.originalACF);
      // if( !acfChanges )
      //   return true;

      this.menu.acf.last_save_timestamp = this.phpTimestamp();

      let acfFields = { fields: this.menu.acf };
      return axios
        .put(
          `${this.wpData.rest_url}/acf/v3/${this.wpData.cpts.menuBlocks}/${this.menu.id}`,
          acfFields,
          { headers: { Authorization: `Bearer ${this.authToken}` } }
        )
        .then(res => {
          // this.$notify(`ACF Updated id ${this.menu.id}`);
          console.log(`[ACF Updated for ${this.menu.id}]`, res);
          this.originalACF = _cloneDeep(this.menu.acf);
          return res;
        });
    }, // updateMenuACF()

    deleteMenu() {
      this.disableEdit();

      let menu_id = this.menu.id;

      console.log("[ Removing Menu... ]", this.menu);
      if (this.menu.new) {
        this.$emit("removeMenu", menu_id);
      } else {
        // Delete from WP
        return this.$store.dispatch("authPromise").then(authToken => {
          axios
            .delete(
              `${this.wpData.rest_url}/wp/v2/${this.wpData.cpts.menuBlocks}/${menu_id}`,
              { headers: { Authorization: `Bearer ${authToken}` } }
            )
            .then(res => {
              console.log("[ Menu Deleted ]", res);
              this.$emit("removeMenu", menu_id);
            });
        });
      }
    }, // deleteMenu

    checkForUpdates() {
      const fields = "id,title,acf"; // retrieve data for specific fields only.

      const timestampURL = `${this.wpData.rest_url}/acf/v3/${this.wpData.cpts.menuBlocks}/${this.menu.id}/last_save_timestamp`;

      axios(timestampURL).then(res => {
        let dbTimestamp = res.data.last_save_timestamp;
        if (dbTimestamp > this.birthday) {
          return this.fetchUpdates();
        }
      });
    }, // checkForUpdates

    fetchUpdates() {
      let menuPostPromise = axios(
        `${this.wpData.rest_url}/wp/v2/${this.wpData.cpts.menuBlocks}/${this.menu.id}/?fields=post_title`
      );
      let menuAcfPromise = axios(
        `${this.wpData.rest_url}/acf/v3/${this.wpData.cpts.menuBlocks}/${this.menu.id}`
      );

      return axios.all([menuPostPromise, menuAcfPromise]).then(
        axios.spread((postRes, acfRes) => {
          // this.$notify({title:`Refreshed ${this.menu.acf.menu_title} menu`, type:'success'});
          console.log(`Refreshed ${this.menu.acf.menu_title} menu`);
          console.log({ post: postRes, acf: acfRes });

          this.updateBirthday();

          this.menu.acf = acfRes.data.acf;

          // this.$store.commit('refreshMenu', this.menu);

          // this.$emit('refreshMenu', this.menu);
        })
      );
    }, // fetchUpdates

    phpTimestamp() {
      return Math.round(Date.now() / 1000);
    }, // phpTimestamp

    updateBirthday() {
      this.birthday = this.phpTimestamp();
    }, // updateBirthday

    isEqualCustomizer(objValue, otherValue, key) {
      if (key == "last_save_timestamp") {
        return true;
      }
    }, // isEqualCustomizer

    addTogoBodyClass() {
      let body = document.body;
      let className = "togo-body";
      if (body.classList) body.classList.add(className);
      else body.className += " " + className;
    } // addTogoBodyClass
  }, // methods
  mounted() {
    // fitty('.menu-title');
  },
  created() {
    this.originalACF = _cloneDeep(this.menu.acf);

    if (parseInt(this.wpData.menu_board_id) !== -1) {
      this.updateInterval = setInterval(this.checkForUpdates, 30 * 1000);
    }

    if (Number(this.wpData.togo)) {
      this.addTogoBodyClass();
    }
  },
  beforeDestroy() {
    clearInterval(this.updateInterval);
  },
  data() {
    return {
      buttons: [
        {
          title: "Undo All",
          icon: "undo",
          // iconOnly : true,
          clickHandler: this.clearChanges,
          conditional: () => {
            return this.hasChanges;
          }
        },
        {
          title: "Save",
          icon: "save",
          iconOnly: true,
          clickHandler: this.saveMenu,
          conditional: () => {
            return this.hasChanges;
          }
        },
        {
          title: "Delete Menu",
          icon: "delete",
          iconOnly: true,
          clickHandler: this.deleteMenu
        },
        {
          title: "Section",
          icon: "add_circle",
          // iconOnly : true,
          // dragGroup : {
          //   name : 'item-addons',
          //   pull : 'false'
          // },
          clickHandler: this.addSection
          // dragStartAction : this.addButtonDragStart,
          // dragEndAction : this.addButtonDragEnd,
          // dragChangeAction : this.addButtonDragChange,
        }
        // {
        //   title : 'Refresh',
        //   icon : 'refresh',
        //   iconOnly : true,
        //   clickHandler : this.checkForUpdates,
        //   // dragStartAction : this.addButtonDragStart,
        //   // dragEndAction : this.addButtonDragEnd,
        //   // dragChangeAction : this.addButtonDragChange,
        // },
      ]
    };
  }
};
</script>

<style lang="scss">
$gutter: 20px;

.menu.drinks-menu {
  flex-wrap: wrap;
  flex: 1 0 calc(100% - 40px);

  @media (max-width: 768px) {
    min-width: auto;
  }

  .menu-inner {
    margin: 0 (100% * (1/24));
    justify-content: space-around;
    @media (max-width: 1254px) {
      margin: 0;
    }
  }
  &.selected,
  &:hover {
    .menu-inner > .button-cluster {
      display: flex;
    }
  }

  &.togo-menu {
    width: 11in;
    max-width: 11in;
    height: 8.5in;
    padding-left: 0;
    padding-right: 0;
    .menu-inner {
      $w: 43%;
      flex: 0 0 $w;
      margin: 0 #{(50 - $w) / 2};
      display: block;
      .drinks-menu-col {
        padding: 0;
        flex: 0 0 100%;
        min-width: 0;
        .section {
          padding-top: 5px;
        }
        .section-title-wrap {
          // margin-bottom:0;
        }
        .menu-items {
          .item {
            $p: 0.23em;
            padding-top: $p;
            padding-bottom: $p;
            font-size: 1rem;
          }
          .item-title {
            flex-basis: 75%;
          }
          .item-description {
            font-size: 0.85rem;
          }
        }
        &.drinks-menu-col-right {
          .menu-subsections .subsection {
            width: calc(50% - 40px);
            // margin-left:20px;
            // margin-right:10px;
          }
        }
      }
    } // .menu-inner
    .togo-menu-cover-wrap {
      width: 35%;
      margin: 0 auto;
      text-align: center;

      .togo-location-title {
        margin-top: 38px;
        margin-bottom: 27px;
        letter-spacing: 0.03em;
        font-family: "Jaldi", sans-serif;
        font-weight: bold;
        text-transform: uppercase;
      }
      .togo-cover-img {
        height: 294px;
        width: auto;
      }
      .togo-tagline {
        font-size: 35px;
        line-height: 1;
        margin: 1.55em 0;
        letter-spacing: 0.03em;
        font-family: "Jaldi", sans-serif;
        font-weight: bold;
      }
      .drinks-menu-footer {
        flex-basis: 100%;
      }
    }
    .drinks-menu-footer {
      flex: 0 0 35%;
      width: 100%;
      padding: 0;
    }
    .drinks-menu-col-left-logo {
      display: none;
    }
    .drinks-menu-col-right {
      margin: 0;
    }
    .section {
      &.has-subsections {
        padding-bottom: 0;
      }
    }

    .item-wrap {
      @media (min-width: 768px) {
        flex: 0 0 calc(50% - 10px);
        &:nth-child(odd) {
          margin-right: 10px;
        }
        &:nth-child(even) {
          margin-left: 10px;
        }
      }
    }
  } // .togo-menu
} // .menu.drinks-menu

.menu-col.drinks-menu-col {
  transition: background-color 0.3s ease;
  position: relative;
  flex-wrap: wrap;
  @media (min-width: 768px) {
    flex: 0 0 (100% * (10/24));
    min-width: 580px;
    padding-left: 10px;
    padding-right: 10px;
  }
  @media (max-width: 1400px) {
    flex-grow: 1;
  }
  @media (max-width: 1360px) {
    padding-bottom: 0;
  }
}

.drinks-menu-col {
  display: flex;
  .sections {
    flex: 0 0 100%;
  }
  $margin: 7px;
  .menu-items {
    display: flex;
    flex-wrap: wrap;

    .item-wrap {
      flex: 1 0 100%;
      @media (min-width: 768px) {
        flex: 0 0 calc(50% - 20px);
        &:nth-child(odd) {
          margin-right: 20px;
        }
        &:nth-child(even) {
          margin-left: 20px;
        }
      }
    }
    .item {
      padding-top: $margin;
      padding-bottom: $margin;
      .item-title {
        flex: 1 0 75%;
      }
      .item-prices {
        flex: 0 0 25%;
        text-align: right;
      }
    }
  }
} // .drinks-menu-col

.drinks-menu-col-right {
  @media print, (min-width: 1360px) {
    margin-top: $gutter * 4;
  }
  &.empty {
    align-self: stretch;
    &:after {
      background-color: rgba(black, 0.05);
      content: "";
      position: absolute;
      $padding: 10px;
      padding: $padding;
      left: -$padding;
      top: -$padding;
      width: 100%;
      height: 100%;
    }
  }

  .section {
    float: left;
    width: 100%;
    padding-left: $gutter;
    padding-right: $gutter;
  }

  $subsectionGutter: $gutter;
  .section.has-subsections {
    padding-left: $subsectionGutter;
    padding-right: $subsectionGutter;
    .section-title-wrap {
      margin-left: -$subsectionGutter;
    }
  }
  .menu-subsections {
    float: left;
    margin-left: -$subsectionGutter * 2;
    margin-right: -$subsectionGutter * 2;
    @media (max-width: 768px) {
      width: calc(100% + 40px);
    }

    .subsection {
      width: calc(50% - #{$subsectionGutter * 2});
      float: left;
      margin-right: $subsectionGutter;
      margin-left: $subsectionGutter;

      @media (max-width: 768px) {
        width: 100%;
      }
      .menu-items .item-wrap {
        flex: 0 0 100%;
        margin: 0;
      }
    }
  }
} // .drinks-menu-col-right

@media (max-width: 1440px) {
  .drinks-menu-col-left-logo,
  .menu-board-footer-text {
    display: none;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Menus/DrinksMenu.vue